import classNames from 'classnames'
import { NextPage } from 'next'
import Link from 'next/link'
import { t } from '../../../utils'
import { useAuth } from '../../../utils/auth'
import StoreLayout from '../components/StoreLayout'
import styles from './_preSignUp.module.scss'

const PreSignUpPage: NextPage & {
  theme?: string
} = () => {
  const optionsList = (
    <ul>
      <li>{t('Access to the Worship Online Store')}</li>
      <li>{t('50% off entire store')} </li>
      <li>{t('Access to full library of premium tutorials and lessons')}</li>
      <li>{t('Chord/Lyric/Tab charts')}</li>
      <li>{t('Build/Create setlists')}</li>
    </ul>
  )
  const { currentUser } = useAuth()
  return (
    <StoreLayout pageTitle={t('WorshipOnline - Pre sign up')}>
      <div className={classNames('section', styles.storePreSignUpPage)}>
        <div className="container">
          <div className={classNames('columns is-centered')}>
            <div className={classNames('column is-6', styles.storeOption)}>
              <div className={styles.storeMembership}>
                <h2>{t('Worship Online Membership')}</h2>
                {optionsList}
                <Link
                  href="https://worshiponline.com/pricing/"
                  prefetch={false}
                  className="button is-primary is-large is-inline-block is-rectangular is-wide"
                >
                  {t('start free trial')}
                </Link>
              </div>
            </div>
            {!currentUser?.onFreePlan && (
              <div className={classNames('column is-6', styles.storeOption)}>
                <div className={styles.storeFree}>
                  <h2>{t('Free Store Only')}</h2>
                  {optionsList}
                  <Link
                    href="/signup"
                    prefetch={false}
                    className="button is-primary is-large is-inline-block is-rectangular is-wide"
                  >
                    {t('create free account')}
                  </Link>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </StoreLayout>
  )
}
PreSignUpPage.theme = 'dark'
export default PreSignUpPage
